const FormValidation = function (): void {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll('.needs-validation');

    // Loop over them and prevent submission
    Array.from(forms).forEach(form => {
        form.addEventListener('submit', (event: SubmitEvent) => {
        if (!(<HTMLFormElement>form).checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
            const invalidElement = <HTMLElement>form.querySelector(':invalid');
            if (invalidElement)
            {
                invalidElement.focus();
            }
        }
        else {
            const submitButtons = form.querySelectorAll('[formaction]');
            if (submitButtons)
            {
                Array.from(submitButtons).forEach((button: HTMLButtonElement) => {
                    const spinner : HTMLSpanElement = button.querySelector("[data-article-spinner");
                    if (spinner)
                        spinner.classList.remove("visually-hidden");
                    
                    button.disabled = true;
                });
            }
        }

        form.classList.add('was-validated');
        }, false);
    });
};

export default FormValidation;